module.exports = __webpack_public_path__ + "static/media/seguros-mundial-bumper-selected.f6bafd9f.svg";